import { AiMetricsProvider } from "apps/ai-metrics/context/AiMetricsContext";
import { UIEvent, useRef, useState } from "react";
import { AdoTab } from "../AdoTab/AdoTab";
import { DashboardHeader } from "../DashboardHeader/DashboardHeader";
import { RefreshStatusBanner } from "../RefreshStatusBanner/RefreshStatusBanner";
import { useStyles } from "./DashboardShell.styles";
import { ConstantValues } from "common/constants";

const SCROLL_COLLAPSE_THRESHOLD = 24;

export const DashboardShell = (): JSX.Element => {
  const styles: ReturnType<typeof useStyles> = useStyles();
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);
  const scrollWrapperRef = useRef<HTMLDivElement>(null);

  const handleScroll = (event: UIEvent<HTMLDivElement>): void => {
    setIsHeaderCollapsed(
      event.currentTarget.scrollTop > SCROLL_COLLAPSE_THRESHOLD,
    );
  };

  return (
    <div className={styles.shell}>
      <DashboardHeader isCollapsed={isHeaderCollapsed} />
      <RefreshStatusBanner />
      <div
        className={styles.scrollWrapper}
        onScroll={handleScroll}
        ref={scrollWrapperRef}
      >
        <AiMetricsProvider storageKey={ConstantValues.AI_METRICS_FILTERS_ADO}>
          <div className={styles.panel}>
            <AdoTab />
          </div>
        </AiMetricsProvider>
      </div>
    </div>
  );
};
